module.exports = __webpack_public_path__ + "static/media/python.f97df66d.svg";